<template>
  <div id="view-patient-details-profile-form" class="h-100">
    <div class="row h-100 mt-2">
      <div class="col-xl-12 col-md-12 col-sm-12" style="height:calc(100% - 48px);overflow-y: scroll;">

        <div class="row justify-content-center">
          <div class="col-md-4 col-6 profile-image" :style="{
                  backgroundImage:
                        'url(' +
                        (patient.profileImage
                          ? baseUrl + '/file/' + patient.profileImage
                          : avatarImage) +
                        ')',
                }">
          </div>
        </div>
        <div class="row justify-content-center" style="margin-top: 1em; margin-bottom: 1em;">
          <div class="col-8 text-center" style="font-size: 1.2em;">
            {{patient.patientId}}
          </div>
        </div>
        <card>
          <div class="row" id="view-patient-details">
            <h4 class="sub-heading col-md-12 mt-0">
              <!-- Patient details -->
              {{$t("message.Patient detials")}}
            </h4>

            <div class="col-md-6 pl-4">
              <div v-if="patient.firstName || patient.lastName" class="row mb-1">
                <div class="col-4 patient-field">
                  <!-- Name -->
                  {{$t("message.Name")}}
                </div>
                <div class="col-8 patient-value">
                  <span class="pl-2">{{  patient.firstName + " " + patient.lastName}}</span>
                </div>
              </div>

              <div v-if="patient.gender" class="row mb-1">
                <div class="col-4 patient-field">
                  <!-- Gender -->
                  {{$t("message.Gender")}}
                </div>
                <div class="col-8 patient-value">
                  <span class="pl-2">{{  patient.gender}}</span>
                </div>
              </div>

              <div v-if="patient.dob" class="row mb-1">
                <div class="col-4 patient-field">
                  <!-- Dob -->
                  {{$t("message.Age")}}
                </div>
                <div class="col-8 patient-value">
                  <span class="pl-2"> {{getAge(patient.dob)}}</span>
                </div>
              </div>

              <div v-if="patient.mobileNumber" class="row mb-1">
                <div class="col-4 patient-field">
                  <!-- Phone -->
                  {{$t("message.Phone")}}
                </div>
                <div class="col-8 patient-value"> <span class="pl-2">{{  patient.mobileNumber}}</span> </div>
              </div>

              <div v-if="patient.email" class="row mb-1">
                <div class="col-4 patient-field">
                  <!-- Email -->
                  {{$t("message.Email")}}
                </div>
                <div class="col-8 patient-value"> <span class="pl-2"> {{  patient.email}} </span>
                </div>
              </div>
            </div>
          </div>
        </card>

        <card v-if="hasAddress">
          <div class="row" id="view-patient-address">
            <h4 class="sub-heading col-md-12 mt-0">
              {{ $t("message.Address Details") }}
            </h4>

            <div class="col-md-6 pl-4">
              <div class="row mb-1">
                <div class="col-12">
                  <span v-if="patient.address.line1"> {{patient.address.line1}}, </span> <br> <span v-if="patient.address.line2"> {{patient.address.line2}}, </span> <br>
                  <span v-if="patient.address.country"> {{patient.address.country}}, </span>
                  <span v-if="patient.address.state"> {{patient.address.state}}, </span> <span v-if="patient.address.city"> {{patient.address.city}} </span> <span v-if="patient.address.zip"> {{patient.address.zip}} </span>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
    <n-button native-type="submit" type="primary" round size="lg" @click.native.stop="editPatient(patient)" style="top: auto;
                  bottom: 0px;
                  left: 50%;
                  transform: translateX(-50%);
                  position: absolute;
                  z-index:2001;">
      <i class="fa fa-pencil-alt mr-1" aria-hidden="true"></i>
      <!-- Edit -->
      {{$t("message.Edit")}}
    </n-button>
    <modal :alertModal="alertModal"></modal>
  </div>
</template>
<script>
import Modal from "../components/Alert";
var moment = require("moment");
import { Select, Option } from "element-ui";
import avatarImage from "@/assets/img/proAvatar.png";

export default {
  components: {
    Modal,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      patient: {},
      patientAgeYears: null,
      patientAgeMonths: null,
    };
  },

  async mounted() {
    try {
      this.patient = await this.$store.dispatch(
        "getPatient",
        this.$route.params.patientId
      );

      var m = moment(this.patient.dob);
      var years = moment().diff(m, "years", false);
      this.patientAgeYears = years;

      m = moment(m).add(years, "years");

      var months = moment().diff(m, "months", false);
      this.patientAgeMonths = months;
      if (this.patient.mobileNumber) {
        this.mobileNumber = this.patient.mobileNumber;
      }
    } catch (e) {
      console.log(e);
    }
  },

  computed: {
    hasAddress() {
      return (
        this.patient.address.line1 ||
        this.patient.address.line2 ||
        this.patient.address.country ||
        this.patient.address.state ||
        this.patient.address.city
      );
    },
  },
  methods: {
    async editPatient(patient) {
      console.log("routing to edit patient : ", patient._id);
      this.$router.push({ path: "/patients/edit/" + patient._id });
    },
    calculateDob() {
      let currentYear = new Date().getUTCFullYear();
      let yearOFBirth = currentYear - (this.patientAgeYears || 0);

      let currentMonth = new Date().getMonth() + 1;
      let monthOfBirth = currentMonth - (this.patientAgeMonths || 0);

      if (monthOfBirth == 0 || Math.sign(monthOfBirth) == -1) {
        --yearOFBirth;
        monthOfBirth = 12 + monthOfBirth;
      }
      this.patient.dob = monthOfBirth + "/01/" + yearOFBirth;
    },
  },
  watch: {
    patientAgeYears: function () {
      this.calculateDob();
    },
    patientAgeMonths: function () {
      this.calculateDob();
    },
  },
};
</script>
<style lang="scss">
#view-patient-details-profile-form .tab-content.tab-subcategories {
  width: 100%;
}

#view-patient-details .patient-field {
  font-size: smaller;
  font-weight: 700;
  color: #9a9a9a;
  padding-right: 0;
}

#view-patient-details .row {
  align-items: center;
}

#view-patient-details .patient-value {
  padding-left: 0;
}
</style>


<style scoped>
.profile-image {
  height: 150px;
  max-width: 150px;
}
</style>
